import SettingsCard from "../SettingsCard"
import FollowUpSchedule from "../../jobs/Proposals/Followup/FollowUpSchedule"
import { useState } from "react"
import { isEqual } from "lodash"
import { AutomationSchedule } from "../../../domain/proposals/settings/proposalSettings"
import { useUpdateDefaultFollowUpScheduleMutation } from "../../../domain/proposals/settings/proposalSettingsQueries"
import { Button } from "antd"

type Props = {
  onEditEmailTemplates: () => void
}

const FollowUpScheduleSettings = ({ onEditEmailTemplates }: Props) => {
  const [serverState, setServerState] = useState<AutomationSchedule | undefined>(undefined)
  const [automatedSchedule, setAutomatedSchedule] = useState<AutomationSchedule | undefined>(undefined)
  const [hasErrors, setHasErrors] = useState(false)
  const updateDefaultFollowUpScheduleMutation = useUpdateDefaultFollowUpScheduleMutation()

  const isChanged = !isEqual(automatedSchedule, serverState)

  return <SettingsCard
    title="Follow-Up Schedule"
    description="Set a default follow-up schedule to automatically remind customers about their proposals after they've been sent."
    onUpdate={() => {
      if (automatedSchedule) {
        updateDefaultFollowUpScheduleMutation.mutate(automatedSchedule)
      }
    }}
    isUpdating={updateDefaultFollowUpScheduleMutation.isLoading}
    updateDisabled={!isChanged || hasErrors || automatedSchedule === undefined}
    additionalActions={<Button onClick={onEditEmailTemplates}>Edit Templates</Button>}
  >
    <FollowUpSchedule
      onScheduleChange={(errors, schedule)=> {
        setHasErrors(errors)
        setAutomatedSchedule(schedule)}
      }
      onServerStateChange={(schedule)=> {
        setServerState(schedule)
      }}
      hideEditTemplatesLink
    />
  </SettingsCard>
}

export default FollowUpScheduleSettings
